"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthService = void 0;
var OAuthService;
(function (OAuthService) {
    OAuthService["Google"] = "google";
    OAuthService["Asana"] = "asana";
    OAuthService["Microsoft"] = "microsoft";
    OAuthService["Slack"] = "slack";
})(OAuthService || (exports.OAuthService = OAuthService = {}));
